import React from "react"
import Recaptcha from "react-google-recaptcha"
import { useIntl } from "react-intl";

import PanelWrapper from "../../internal/panelWrapper/PanelWrapper"
import { InputFormField, SelectFormField, CheckboxFormField, ValidateEmail, EncodeFormData } from "../FormHelpers"
import { resolveRichText } from "../../../utils/richText"
import * as styles from "../GeneralFormStyles.module.scss"
import { GetRecaptchaKey } from "../../../utils/env";


const IndustryContactForm = ({ blok }) => {
  const intl = useIntl()
  const [showSuccess, setShowSuccess] = React.useState(false)
  const [isLoading, setIsLoading] = React.useState(false)
  const [errorMessage, setErrorMessage] = React.useState("")
  
  const [state, setState] = React.useState({})
  const recaptchaRef = React.createRef()
  const [buttonDisabled, setButtonDisabled] = React.useState(true)
  
  const handleChange = e => {
    setState({ ...state, [e.target.name]: e.target.value })
  };
  const handleSubmitForm = (e) => {
    setIsLoading(true)
    e.preventDefault()
    const form = e.target

    if(state.email) {
      if(!ValidateEmail(state.email)) {
        setErrorMessage("Please enter a valid email address")
        setIsLoading(false)
        return
      }
    }

    let recaptchaValue
    if(recaptchaRef.current) {
      recaptchaValue = recaptchaRef.current.getValue()
    }

    fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: EncodeFormData({
        "form-name": form.getAttribute("name"),
        "g-recaptcha-response": recaptchaValue,
        ...state,
      }),
    })
    .then((response) => {
      console.log(response)
      if (response.status === 200) {
        setIsLoading(false)
        setShowSuccess(true)
        setErrorMessage("")
      } else {
        setIsLoading(false)
        setErrorMessage(
          intl.messages["component.form.contact_form.error_message_generic"]
        )
        console.error(response)
      }
    })
    .catch((err) => {
      setIsLoading(false)
      console.error(err)
    })
  }

  let industryOptions = []
  if(blok.industry_options) {
    industryOptions = blok.industry_options.split('\n')
  }

  return (
    <PanelWrapper blok={blok}>
        {showSuccess ? (
          <div className={styles.success}>
            <br/>
            <div dangerouslySetInnerHTML={resolveRichText(blok.success_content)} />
          </div>
        ) : (
          <form
            name="industry-contact-form"
            data-netlify="true"
            data-netlify-recaptcha="true"
            onSubmit={handleSubmitForm}
            className={styles.formWrapper}
            method="POST"
          >
            <noscript>This form won't work with Javascript disabled</noscript>
            <input type="hidden" name="form-name" value="industry-contact-form" />
            {/* First Name */}
            <InputFormField
              field_name="first_name"
              placeholder="First Name"
              label="First Name"
              disabled={isLoading}
              onChange={handleChange}
              is_required={true} />
            {/* Last Name */}
            <InputFormField
              field_name="last_name"
              placeholder="Last Name"
              label="Last Name"
              disabled={isLoading}
              onChange={handleChange}
              is_required={true} />
            {/* Company */}
            <InputFormField
              field_name="company"
              placeholder="Company"
              label="Company"
              disabled={isLoading}
              onChange={handleChange}
              is_required={true} />
            {/* Industry */}
            <SelectFormField
              options={industryOptions}
              field_name="industry"
              label="Industry"
              disabled={isLoading}
              onChange={handleChange}
              is_required={true} />
            {/* Industry Other */}
            <div className={state && state.industry === "Other" ? "" : styles.hidden}>
              <InputFormField
                field_name="other_industry"
                placeholder="Industry"
                label="Other Industry"
                disabled={isLoading}
                onChange={handleChange}
                is_required={state && state.industry === "Other" ? true : false} />
            </div>
            {/* Job Title */}
            <InputFormField
              field_name="job_title"
              placeholder="Job Title"
              label="Job Title"
              disabled={isLoading}
              onChange={handleChange}
              is_required={true} />
            {/* Country */}
            <InputFormField
              field_name="country"
              placeholder="Country"
              label="Country"
              disabled={isLoading}
              onChange={handleChange}
              is_required={true} />
            {/* Email */}
            <InputFormField
              field_name="email"
              placeholder="Email"
              label="Email"
              disabled={isLoading}
              onChange={handleChange}
              is_required={true} />
            {/* Receive Emails */}
            <CheckboxFormField
              field_name="receive_emails"
              label={blok.email_label}
              disabled={isLoading}
              onChange={handleChange}
              is_required={false} />
            {/* ERROR Message */}
            {errorMessage ? (
              <p className={styles.error}>{errorMessage}</p>
            ) : null}
            {/* Recaptcha */}
            <Recaptcha 
              ref={recaptchaRef}
              sitekey={GetRecaptchaKey() || "TEST"}
              size="normal"
              id="recaptcha-google"
              onChange={() => setButtonDisabled(false)} />
            {/* Submit Button */}
            <div style={{ textAlign: "center", paddingTop: "40px" }}>
              <button
                type="submit"
                disabled={buttonDisabled || isLoading}
                className={styles.btnSolidBlue}>
                  Submit
              </button>
            </div>
          </form>
        )}
    </PanelWrapper>
  )
}


export default IndustryContactForm